<template>
  <el-dialog :title="popType?'赠送额度':'扣减额度'" :visible.sync="formVisible" :close-on-click-modal="false" width="900px">
    <el-form ref="dataForm" label-position="right" :rules="formRules" :model="form" size="small" label-width="100px">
      <el-form-item label="额度：" prop="moneyType">
        <el-select v-model="form.moneyType" placeholder="请选择" @change="getOption()">
          <el-option label="佣金" :value="5" v-if="!popType"></el-option>
          <el-option label="余额账户" :value="1"></el-option>
          <el-option label="零售价账户" :value="2"></el-option>
          <el-option label="赠送账户" :value="3"></el-option>
          <el-option label="积分" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="" prop="money">
        <el-input v-model="form.money" :placeholder="`请输入${popType?'赠送':'扣减'}额度`" />
      </el-form-item>
      <el-form-item label="客户：" prop="customerId" class="width100" v-if="form.moneyType">
        <el-select v-model="form.customerId" :placeholder="`请选择需要${popType?'赠送':'扣减'}额度的客户`" clearable filterable :filter-method="customerFilter" @change="handleCustomerChange">
          <el-option :label="`${item.name} (${item.pho})(${item.levelName})${item.cityCompanyName || ''}`" :value="item.id" v-for="item in clientOption" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="popType?'赠送原因：':'扣减原因：'" prop="userCode" class="width100">
        <el-select v-model="form.userCode" placeholder="请选择" filterable @change="handleBankRelatedChange">
          <el-option v-for="item in filteredReasonOptions" :key="item.id" :label="item.configName" :value="item.configKey"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否选择银行：" prop="isSelectBank" class="width100">
        <el-radio-group v-model="form.isSelectBank" @change="handleSelectBankChange">
          <el-radio :label="false">否</el-radio>
          <el-radio :label="true">是</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="银行：" prop="bankName" class="width100" v-if="form.isSelectBank" :required="form.isSelectBank">
        <div style="display: flex; align-items: center;">
          <el-select v-model="form.bankName" placeholder="请选择银行" filterable clearable style="flex: 1;">
            <el-option :label="item.bankName" :value="item.bankName" v-for="(item, index) in visibleBankList" :key="index"></el-option>
          </el-select>
          <el-button type="text" @click="toggleBankFilter" style="margin-left: 10px;">
            {{ showAllBanks ? '按城市过滤' : '显示全部' }}
          </el-button>
        </div>
      </el-form-item>
      
      <el-form-item label="备注：" prop="remark" class="width100">
        <el-input type="textarea" :placeholder="`请输入${popType?'赠送':'扣减'}原因`" v-model="form.remark" maxlength="200" show-word-limit />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading" :disabled="isSubmitDisabled">
        {{ confirmButtonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import managecustomerwalletApi from '@/api/cust/managecustomerwallet'
import sysDataconstantApi from '@/api/config/sysDataconstant'
import submitLockMixin from '@/utils/submitLockMixin'
function initFormBean() {
  const formBean = {
    customerId: null,
    moneyType: null,
    userCode: null,
    remark: null,
    money: null,
    isSelectBank: false,
    bankName: null
  }
  return formBean
}

export default {
  mixins: [submitLockMixin],
  //popType 0:新增 1:编辑 2:修改身份
  props: {
    reasonOptions: Array,
    popType: Number
  },
  watch: {
    'form.customerId': {
      handler() {
        // 客户切换时，若当前银行不在过滤列表中则清空
        if (this.form.bankName && !this.showAllBanks) {
          this.$nextTick(() => {
            const exists = this.filteredBankList.some(it => it.bankName === this.form.bankName)
            if (!exists) {
              this.form.bankName = null
            }
          })
        }
      }
    }
  },
  data() {
    return {
      bankRequiredReasonKeys: [
        //这里控制那个原因需要选择银行
        '0',
        '01'
      ],
      form: initFormBean(),
      isLoading: false,
      formVisible: false,
      formRules: {
        customerId: [{
          required: true,
          message: '请选择客户',
          trigger: 'change'
        }],
        moneyType: [{
          required: true,
          message: '请选择账户',
          trigger: 'change'
        }],
        userCode: [{
          required: true,
          message: '请选择赠送原因',
          trigger: 'change'
        }],
        money: [{
          required: true,
          message: '请输入额度',
          trigger: 'blur'
        }, { pattern: /^(?!0(\.0+)?$)(\d+(\.\d+)?|\.\d+)$/, message: '请输入正确的额度' }],
        isSelectBank: [{
          validator: (rule, value, callback) => {
            if (this.bankRequiredReasonKeys.includes(this.form.userCode) && value !== true) {
              callback(new Error('该原因必须选择银行'))
              return
            }
            callback()
          },
          trigger: 'change'
        }],
        bankName: [{
          // “是否选择银行”选是时银行必填；选否时不校验
          validator: (rule, value, callback) => {
            if (this.form.isSelectBank === true && !value) {
              callback(new Error('请选择银行'))
              return
            }
            callback()
          },
          trigger: ['change', 'blur']
        }]
      },
      clientOption: [],
      bankList: [],
      showAllBanks: false,
      selectedCustomer: null
    }
  },
  computed: {
    filteredReasonOptions() {
      if (this.form.moneyType !== 4 && this.reasonOptions) {
        return this.reasonOptions.filter(item => item.dataType === 1)
      }
      return this.reasonOptions || []
    },
    filteredBankList() {
      // 仅显示已启用的银行
      const enabled = this.bankList.filter(it => String(it.isEnable) === '1')
      const selectedCityCompanyId = this.selectedCustomer && this.selectedCustomer.cityCompanyId

      console.log('选中的客户:', this.selectedCustomer)
      console.log('客户城市公司ID:', selectedCityCompanyId)
      console.log('银行列表:', this.bankList)

      // 按城市公司ID进行过滤（银行 cityCompanyId 与 客户 cityCompanyId 匹配）
      if (selectedCityCompanyId !== undefined && selectedCityCompanyId !== null && selectedCityCompanyId !== '') {
        const ccIdNum = Number(selectedCityCompanyId)
        const filtered = enabled.filter(it => {
          const bankCityId = Number(it.cityCompanyId || it.cityId)
          console.log(`银行 ${it.bankName} 的城市公司ID: ${bankCityId}, 匹配: ${bankCityId === ccIdNum}`)
          return bankCityId === ccIdNum
        })
        console.log('过滤后的银行列表:', filtered)
        return filtered
      }

      // 未选择客户时，返回全部启用银行
      return enabled
    },
    visibleBankList() {
      return this.showAllBanks ? this.bankList.filter(it => String(it.isEnable) === '1') : this.filteredBankList
    }
  },
  created() {
    // this.getOption()
    this.getBankList()
  },
  methods: {
    shouldRequireBank() {
      return this.form.isSelectBank
    },
    handleBankRelatedChange() {
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.clearValidate('bankName')
        }
      })
    },
    // 切换“是否选择银行”：选否时清掉已选银行，两种情况都先清掉残留的校验提示，
    // 必填与否由 bankName 的 validator 在提交时统一判定
    handleSelectBankChange(val) {
      if (val !== true) {
        this.form.bankName = null
      }
      this.handleBankRelatedChange()
    },
    toggleBankFilter() {
      this.showAllBanks = !this.showAllBanks
    },
    getBankList() {
      sysDataconstantApi.fetchBatchCode({ code: 'lineUpMoneyBankType' }).then(({ data }) => {
        this.bankList = data.list[0].content ? JSON.parse(data.list[0].content) : []
      })
    },
    customerFilter(e) {
      this.getOption(e)
    },
    handleCustomerChange(val) {
      // 客户选择改变时，保存选中的客户信息
      const selected = this.clientOption.find(it => it.id === val)
      if (selected) {
        this.selectedCustomer = selected
        console.log('选中客户信息:', selected)
      }
    },
    resetForm() {
      this.form = initFormBean()
      this.selectedCustomer = null
    },
    async getOption(e) {
      // 只有在筛选时才清空customerId，blur时不清空
      if (e !== undefined) {
        this.form.customerId = null
      }
      let obj = { pageNo: 1, pageSize: 100, name: e, type: this.form.moneyType }
      const { data } = await managecustomerwalletApi.findAreaCustomerList(obj)
      this.clientOption = data
      console.log('客户列表:', data);
    },

    handleCreate() {
      this.resetForm()
      this.clearCountdownTimer()
      this.formVisible = true
      this.showAllBanks = false
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      // console.log('row: ',row);
      this.resetForm()
      this.clearCountdownTimer()
      this.form = {
        ...row
      }
      this.formVisible = true
      this.showAllBanks = false
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
        this.getOption()
      })
    },
    doCreate() {
      if (this.isSubmitDisabled) return
      if (this.bankRequiredReasonKeys.includes(this.form.userCode) && this.form.isSelectBank !== true) {
        this.$message.warning('该原因必须选择银行')
        return
      }
      if (this.shouldRequireBank() && !this.form.bankName) {
        this.$message.warning('请选择银行')
        this.$nextTick(() => {
          if (this.$refs.dataForm) {
            this.$refs.dataForm.validateField('bankName')
          }
        })
        return
      }
      this.$refs["dataForm"].validate((valid) => {
        if (!valid) {
          return
        }
        this.isLoading = true
        let params = { ...this.form }
        if (this.popType) {
          params.money = params.money * 1
          params.userType = 6
        } else {
          params.money = -params.money * 1
          params.userType = 7
        }
        
        // 处理银行和跨城市参数
        // isSelectBank 显式传给后端，后端据此做同样的"选是则银行必填"校验
        params.isSelectBank = this.form.isSelectBank === true
        if (!this.form.isSelectBank) {
          // 不选择银行
          params.isOtherCity = 0
          params.bankNum = null
        } else {
          // 选择了银行
          params.bankNum = this.form.bankName

          // 判断是否跨城市
          const selectedCityCompanyId = this.selectedCustomer && this.selectedCustomer.cityCompanyId
          if (selectedCityCompanyId && this.form.bankName) {
            // 查找选中的银行
            const selectedBank = this.bankList.find(it => it.bankName === this.form.bankName)
            if (selectedBank) {
              const bankCityId = Number(selectedBank.cityCompanyId || selectedBank.cityId)
              const customerCityId = Number(selectedCityCompanyId)
              
              // 匹配上城市公司：2-不是跨城市才推送，没匹配上：1-跨城市才推送
              params.isOtherCity = (bankCityId === customerCityId) ? 2 : 1
              console.log(`银行城市ID: ${bankCityId}, 客户城市ID: ${customerCityId}, isOtherCity: ${params.isOtherCity}`)
            } else {
              params.isOtherCity = 1
            }
          } else {
            params.isOtherCity = 1
          }
        }
        
        console.log('提交参数: ', params)
        managecustomerwalletApi.giveOrDeductionMoney(params).then((data) => {
          this.postCallback(data)
        }).catch(() => {
        }).finally(() => {
          this.isLoading = false
          this.startCountdown()
        })
      })
    },
    postCallback(data) {
      this.$message.success('操作成功')
      this.formVisible = false
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-cascader {
  width: 100%;
}
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
</style>
